// All content is MOCK data for the frontend-only build.
// Company-specific fields are intentionally left blank ("") for the owner to fill in later.

export const brand = {
  name: "Loansupportindia",
  legalName: "", // e.g. "LS-India Financial Services Pvt. Ltd."
  tagline: "Let's Make Your Dreams Together",
  subtitle:
    "Compare and apply for suitable loan and insurance options from our authorised partners — quick, transparent and secure.",
  phone: "",
  email: "",
  address: "",
  cin: "",
  gstin: "",
  copyrightEntity: "", // shown in footer
  whatsapp: "917980074801", // WhatsApp number (country code + number, no +)
  logo: "/logo-mark.png",
};

// Category background images (bright, for light overlays)
export const categoryImages = {
  personal: "https://images.pexels.com/photos/5900184/pexels-photo-5900184.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  business: "https://images.pexels.com/photos/8475171/pexels-photo-8475171.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  home: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  lap: "https://images.unsplash.com/photo-1565363887715-8884629e09ee?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  vehicle: "https://images.unsplash.com/photo-1671719367451-7bf05ae9549c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  balance: "https://images.unsplash.com/photo-1626266061368-46a8f578ddd6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  insurance: "https://images.unsplash.com/photo-1559734840-f9509ee5677f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  credit: "https://images.unsplash.com/photo-1651126433991-11dda0eb78ff?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
};

export function whatsappLink(message) {
  const text = encodeURIComponent(message || "Hi, I would like to enquire about a loan/financial product.");
  return `https://wa.me/${brand.whatsapp}?text=${text}`;
}

// Compliance disclaimer reused across the site
export const shortDisclaimer =
  "Loansupportindia is a loan/financial-services facilitation and lead-generation platform. We do not directly sanction or disburse loans. Loan approval, interest rate, tenure, processing fee and other terms are determined by the respective lender/financial institution, subject to its eligibility and underwriting policies. Submission of an enquiry does not guarantee loan approval.";

export const navItems = [
  { label: "Home", to: "/" },
  {
    label: "Loans",
    children: [
      { label: "Personal Loan", to: "/loans/personal-loan" },
      { label: "Business Loan", to: "/loans/business-loan" },
      { label: "Home Loan", to: "/loans/home-loan" },
      { label: "Loan Against Property", to: "/loans/loan-against-property" },
      { label: "Vehicle Loan", to: "/loans/vehicle-loan" },
      { label: "Loan Balance Transfer", to: "/loans/balance-transfer" },
    ],
  },
  {
    label: "Products",
    children: [
      { label: "Insurance", to: "/insurance" },
      { label: "Credit Score & Report", to: "/credit-score" },
    ],
  },
  {
    label: "Tools",
    children: [
      { label: "EMI Calculator", to: "/calculators/emi" },
      { label: "GST Calculator", to: "/calculators/gst" },
    ],
  },
  {
    label: "Company",
    children: [
      { label: "About Us", to: "/about" },
      { label: "Lending Partners", to: "/lending-partners" },
      { label: "Insurance Partners", to: "/insurance-partners" },
      { label: "Investors", to: "/investors" },
      { label: "Company Information", to: "/company-information" },
      { label: "Careers", to: "/career" },
      { label: "Blog", to: "/blog" },
      { label: "FAQs", to: "/faqs" },
    ],
  },
  { label: "Contact", to: "/contact" },
];

// Home page service cards — compliant copy, lucide icon keys
export const services = [
  { icon: "User", title: "Personal Loan", desc: "Fulfil your personal financial needs with flexible options from eligible lenders.", to: "/loans/personal-loan", img: categoryImages.personal },
  { icon: "Briefcase", title: "Business Loan", desc: "Grow your business with financing options from our lending partners.", to: "/loans/business-loan", img: categoryImages.business },
  { icon: "Home", title: "Home Loan", desc: "Fulfil your dream of owning a home with a suitable home loan.", to: "/loans/home-loan", img: categoryImages.home },
  { icon: "Landmark", title: "Loan Against Property", desc: "Unlock the value of your property with a Loan Against Property.", to: "/loans/loan-against-property", img: categoryImages.lap },
  { icon: "Car", title: "Vehicle Loan", desc: "Finance your car or two-wheeler through eligible lending partners.", to: "/loans/vehicle-loan", img: categoryImages.vehicle },
  { icon: "Repeat", title: "Loan Balance Transfer", desc: "Transfer your existing loan to potentially lower your obligations.", to: "/loans/balance-transfer", img: categoryImages.balance },
  { icon: "HeartPulse", title: "Health Insurance", desc: "Protect your family with a suitable health insurance policy.", to: "/insurance", img: categoryImages.insurance },
  { icon: "ShieldCheck", title: "Life Insurance", desc: "Secure your family's future with life insurance options.", to: "/insurance", img: categoryImages.insurance },
  { icon: "CarFront", title: "Motor Insurance", desc: "Insure your car and two-wheeler with the right coverage.", to: "/insurance", img: categoryImages.vehicle },
  { icon: "CreditCard", title: "Credit Card", desc: "Explore credit card options that fit your requirements.", to: "/insurance", img: categoryImages.balance },
  { icon: "Gauge", title: "Credit Score & Report", desc: "Understand and monitor your credit health.", to: "/credit-score", img: categoryImages.credit },
  { icon: "TrendingUp", title: "Personal Loan Transfer", desc: "Enhance eligibility and potentially reduce your monthly obligation.", to: "/loans/balance-transfer", img: categoryImages.balance },
];

export const whyChooseUs = [
  { no: "01", icon: "Zap", title: "Efficiency", desc: "A streamlined, digital process that helps you apply and get assistance quickly." },
  { no: "02", icon: "HandHeart", title: "Responsibility", desc: "End-to-end support with transparency and need-based data collection." },
  { no: "03", icon: "Headset", title: "Customer Support", desc: "Helpful assistance throughout your application journey." },
];

export const howItWorks = [
  { no: "1", icon: "FileText", title: "Submit Enquiry", desc: "Provide a few basic details about your requirement." },
  { no: "2", icon: "SearchCheck", title: "Eligibility Assessment", desc: "Your enquiry may be evaluated against applicable lender criteria." },
  { no: "3", icon: "Users", title: "Partner Matching", desc: "Eligible enquiries may be shared with relevant authorised partners, subject to your consent." },
  { no: "4", icon: "BadgeCheck", title: "Lender Decision", desc: "The lender independently evaluates and decides whether to approve the loan." },
];

export const stats = [
  { value: "Multiple", label: "Loan Categories" },
  { value: "Pan-India", label: "Service Coverage" },
  { value: "Secure", label: "Data Handling" },
  { value: "Guided", label: "Application Support" },
];

// Detailed loan products keyed by slug
export const loanProducts = {
  "personal-loan": {
    name: "Personal Loan",
    icon: "User",
    image: categoryImages.personal,
    hero: "Fulfil your personal financial needs",
    intro:
      "Apply online and receive assistance with your personal loan application. Loan approval, interest rate and tenure are determined by the respective lender, subject to its eligibility and underwriting policies.",
    features: [
      "Assistance across multiple lending partners",
      "Flexible tenure options offered by lenders",
      "Minimal documentation as per lender norms",
      "Transparent, need-based data collection",
    ],
    eligibility: [
      "Salaried or self-employed individuals",
      "Minimum age and income as per lender policy",
      "Valid KYC documents",
      "Credit profile assessed by the lender",
    ],
    documents: ["Identity proof (KYC)", "Address proof", "Income proof / bank statements", "Recent photograph"],
    note: "Competitive interest rates may be available, subject to lender eligibility and approval.",
  },
  "business-loan": {
    name: "Business Loan",
    icon: "Briefcase",
    image: categoryImages.business,
    hero: "Financing options to help your business grow",
    intro:
      "Explore business financing options from eligible lending partners. Loan options may be available subject to the lender's credit assessment and terms.",
    features: [
      "Working capital and term loan options via partners",
      "Assistance for self-employed and enterprises",
      "Documentation guidance",
      "Multiple partner options",
    ],
    eligibility: [
      "Business vintage as per lender policy",
      "Minimum turnover criteria by lender",
      "Valid business registration & KYC",
      "Credit profile assessed by the lender",
    ],
    documents: ["Business registration proof", "GST returns / financials", "Bank statements", "KYC of proprietor/partners/directors"],
    note: "Loan options may be available from eligible lending partners, subject to their credit assessment and terms.",
  },
  "home-loan": {
    name: "Home Loan",
    icon: "Home",
    image: categoryImages.home,
    hero: "Fulfil your dream of owning a home",
    intro:
      "Receive assistance with your home loan application. The applicable rate, tenure and eligibility are determined by the lender.",
    features: [
      "Assistance for purchase, construction & renovation",
      "Longer tenure options offered by lenders",
      "Balance transfer guidance",
      "Documentation support",
    ],
    eligibility: [
      "Salaried or self-employed applicants",
      "Age and income criteria as per lender",
      "Property and legal checks by lender",
      "Credit profile assessed by the lender",
    ],
    documents: ["KYC documents", "Income proof", "Property documents", "Bank statements"],
    note: "Interest rate, tenure and eligibility are determined by the respective lender.",
  },
  "loan-against-property": {
    name: "Loan Against Property",
    icon: "Landmark",
    image: categoryImages.lap,
    hero: "Unlock the value of your property",
    intro:
      "Explore a Loan Against Property (LAP) to meet larger financial needs. Loan amount and terms depend on lender valuation and policies.",
    features: [
      "Loan against residential or commercial property",
      "Higher loan amounts subject to valuation",
      "Flexible end-use as per lender norms",
      "Guided documentation",
    ],
    eligibility: [
      "Property owned by applicant",
      "Income and age criteria as per lender",
      "Clear property title (verified by lender)",
      "Credit profile assessed by the lender",
    ],
    documents: ["KYC documents", "Property ownership documents", "Income proof", "Bank statements"],
    note: "Loan amount is subject to lender valuation, eligibility and approval.",
  },
  "vehicle-loan": {
    name: "Vehicle Loan",
    icon: "Car",
    image: categoryImages.vehicle,
    hero: "Finance your car or two-wheeler",
    intro:
      "Get assistance with new or used vehicle financing from eligible lending partners. Terms are set by the lender.",
    features: [
      "New and pre-owned vehicle options",
      "Assistance across lending partners",
      "Documentation guidance",
      "Transparent process",
    ],
    eligibility: [
      "Salaried or self-employed applicants",
      "Age and income criteria as per lender",
      "Valid driving licence & KYC",
      "Credit profile assessed by the lender",
    ],
    documents: ["KYC documents", "Income proof", "Vehicle quotation/details", "Bank statements"],
    note: "Approval and disbursement are subject to the lender's policies.",
  },
  "balance-transfer": {
    name: "Loan Balance Transfer",
    icon: "Repeat",
    image: categoryImages.balance,
    hero: "Transfer your loan, potentially reduce your burden",
    intro:
      "A balance transfer may help enhance eligibility or reduce your monthly obligation. Actual benefit depends on the lender's offer and your profile.",
    features: [
      "Transfer eligible existing loans to partners",
      "Potential to consolidate obligations",
      "Top-up options offered by some lenders",
      "Documentation support",
    ],
    eligibility: [
      "Existing loan in good standing",
      "Repayment track record",
      "Age and income criteria as per lender",
      "Credit profile assessed by the lender",
    ],
    documents: ["Existing loan statement", "KYC documents", "Income proof", "Bank statements"],
    note: "Actual savings depend on the lender's offer, applicable charges and your profile.",
  },
};

export const insuranceProducts = [
  { icon: "HeartPulse", title: "Health Insurance", desc: "A right decision can protect your family and yourself against medical expenses." },
  { icon: "ShieldCheck", title: "Life Insurance", desc: "Secure your family's future with a suitable life insurance plan." },
  { icon: "CarFront", title: "Car Insurance", desc: "Comprehensive and third-party coverage options for your car." },
  { icon: "Bike", title: "Two Wheeler Insurance", desc: "Affordable protection for your two-wheeler." },
];

export const testimonials = [
  { name: "Rahul S.", role: "Salaried Professional", text: "The process was clear and I understood exactly what information was being collected and why before I shared anything." },
  { name: "Priya M.", role: "Small Business Owner", text: "Helpful guidance on documentation. It was made clear that the final decision rests with the lender." },
  { name: "Aman K.", role: "First-time Applicant", text: "Transparent and easy to follow. No misleading promises — just proper assistance." },
];

export const blogPosts = [
  {
    slug: "understanding-emi",
    title: "Understanding EMI: How Your Monthly Loan Payment Is Calculated",
    excerpt: "A simple guide to how EMIs work, what affects them, and how to plan repayments responsibly.",
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxwZXJzb25hbCUyMGZpbmFuY2V8ZW58MHx8fHwxNzg3NDk2Mzg5fDA&ixlib=rb-4.1.0&q=85",
    date: "Jul 2025",
    category: "Loans",
    body: [
      "An EMI (Equated Monthly Instalment) is the fixed amount you repay each month towards a loan. It is made up of both principal and interest.",
      "The EMI depends on three factors: the loan amount (principal), the interest rate charged by the lender, and the tenure. A longer tenure usually means a lower EMI but higher total interest.",
      "Before you borrow, use an EMI calculator to estimate your monthly obligation and ensure it fits comfortably within your budget. Remember that the actual rate, fees and terms are set by the lender.",
    ],
  },
  {
    slug: "improve-credit-score",
    title: "5 Practical Ways to Improve Your Credit Score",
    excerpt: "Your credit score influences loan decisions. Here are responsible habits that can help over time.",
    image: "https://images.unsplash.com/photo-1651126433991-11dda0eb78ff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwzfHxjcmVkaXQlMjBzY29yZXxlbnwwfHx8fDE3ODc0OTYzOTB8MA&ixlib=rb-4.1.0&q=85",
    date: "Jul 2025",
    category: "Credit Score",
    body: [
      "Pay your EMIs and credit card bills on time — payment history is one of the most important factors.",
      "Keep your credit utilisation low and avoid maxing out cards. Maintain a healthy mix of credit and avoid too many enquiries in a short period.",
      "Review your credit report periodically for errors and get them corrected through the relevant bureau. Improvement takes consistent, responsible behaviour over time.",
    ],
  },
  {
    slug: "home-loan-checklist",
    title: "Home Loan Checklist: What to Prepare Before You Apply",
    excerpt: "A handy checklist of documents and considerations for a smoother home loan application.",
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHxob21lJTIwbG9hbnxlbnwwfHx8fDE3ODc0OTYzODl8MA&ixlib=rb-4.1.0&q=85",
    date: "Jul 2025",
    category: "Home Loan",
    body: [
      "Gather your KYC, income proof, bank statements and property documents in advance.",
      "Check your eligibility and understand the total cost — including interest, processing fees, taxes and other charges disclosed by the lender.",
      "Compare options responsibly. The final rate, tenure and approval are decided by the lender after its assessment.",
    ],
  },
  {
    slug: "insurance-basics",
    title: "Insurance Basics: Choosing the Right Cover for Your Family",
    excerpt: "Understand the essentials of health and life insurance and how to evaluate a policy.",
    image: "https://images.pexels.com/photos/5900184/pexels-photo-5900184.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    date: "Jul 2025",
    category: "Insurance",
    body: [
      "Insurance protects you and your family against unexpected financial shocks. Choose a cover based on your needs, dependents and existing liabilities.",
      "Read the policy document carefully — coverage, exclusions, waiting periods and claim process matter.",
      "Insurance products are subject to policy terms and conditions. Please review the details before purchase.",
    ],
  },
  {
    slug: "msme-loan-guide",
    title: "MSME Loan Guide: Financing Options for Small Businesses in India",
    excerpt: "Understand MSME loan basics, eligibility, documents and how small businesses can seek financing responsibly.",
    image: "https://images.pexels.com/photos/8475171/pexels-photo-8475171.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    date: "Jul 2025",
    category: "Business Loan",
    body: [
      "Micro, Small and Medium Enterprises (MSMEs) often need funds for working capital, inventory, equipment or expansion. MSME loan options may be available from eligible lending partners, subject to their credit assessment and terms.",
      "Lenders typically consider factors such as business vintage, turnover, cash flow, GST filings, banking history and the credit profile of the proprietors/partners/directors. Keeping your financial records and GST returns up to date can make the process smoother.",
      "Before you borrow, estimate the EMI with our calculator and understand the total cost — interest, processing fee, GST and other charges disclosed by the lender in its Key Fact Statement. The applicable rate, tenure and approval are decided by the lender after its assessment.",
    ],
  },
  {
    slug: "business-loan-documents",
    title: "Business Loan Documents Checklist for Indian Entrepreneurs",
    excerpt: "A practical checklist of the documents commonly required when applying for a business loan in India.",
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    date: "Jul 2025",
    category: "Business Loan",
    body: [
      "Having your paperwork ready can help your business loan application move faster. While exact requirements vary by lender, commonly requested documents include KYC of the business and promoters, business registration proof, GST returns and recent bank statements.",
      "Lenders may also ask for financial statements, ITRs and details of existing loans. Providing accurate, consistent information helps the lender assess your eligibility.",
      "Remember, Loansupportindia assists with your application — the lender independently evaluates and decides on approval, interest rate and terms as per its policies.",
    ],
  },
];

// Cities for location-based loan landing pages (SEO)
export const cities = [
  { slug: "delhi", name: "Delhi" },
  { slug: "mumbai", name: "Mumbai" },
  { slug: "bangalore", name: "Bangalore" },
  { slug: "hyderabad", name: "Hyderabad" },
  { slug: "chennai", name: "Chennai" },
  { slug: "pune", name: "Pune" },
  { slug: "kolkata", name: "Kolkata" },
  { slug: "ahmedabad", name: "Ahmedabad" },
];

// Which loan products get city landing pages
export const cityLoanSlugs = ["personal-loan", "business-loan", "home-loan", "loan-against-property"];

export const faqs = [
  { q: "Does Loansupportindia provide the loan directly?", a: "No. Loansupportindia is a facilitation and lead-generation platform. We do not directly sanction or disburse loans. The loan is provided by the respective lender/financial institution, subject to its policies." },
  { q: "Does submitting an enquiry guarantee loan approval?", a: "No. Submission of an enquiry does not guarantee approval. The lender independently evaluates your application and decides based on its eligibility and underwriting criteria." },
  { q: "What information do you collect and why?", a: "We collect need-based information to process your enquiry and, with your consent, share it with relevant authorised partners. Please see our Privacy Policy for full details." },
  { q: "Will my data be shared with third parties?", a: "With your explicit consent, your enquiry may be shared with relevant authorised lending or insurance partners. We do not sell your personal information. See our Privacy Policy." },
  { q: "Are you RBI approved / licensed?", a: "We only make regulatory claims that apply to our actual business model. Please refer to the Company Information page for the applicable details." },
  { q: "How are interest rates and charges decided?", a: "The applicable interest rate, APR, processing fee, taxes, tenure, EMI and other charges are determined and disclosed by the lender through its Key Fact Statement / loan documents." },
  { q: "How can I raise a complaint?", a: "You can reach our Grievance Officer through the Grievance Redressal page, which describes the complaint process, response time and escalation route." },
];

// Lending partners — no fake logos; transparent disclosure model
export const lendingPartners = {
  intro:
    "Loansupportindia works to connect eligible enquiries with authorised lending partners (Banks/NBFCs). We publish partner information transparently. We do not display lender logos merely to appear larger. Details of onboarded partners will be listed here.",
  role:
    "Our role: Lending Service Provider / referral / lead-generation partner. The regulated entity (Bank/NBFC) remains the lender and is responsible for underwriting, disclosures and grievance handling under the applicable framework.",
  columns: ["Partner (Legal Name)", "Type", "RBI Registration (if applicable)", "Products", "Our Role", "Grievance Escalation"],
  rows: [
    // Left blank/placeholder — to be filled with verified partners only
    { name: "", type: "Bank / NBFC", rbi: "", products: "", role: "LSP / Referral", grievance: "" },
    { name: "", type: "Bank / NBFC", rbi: "", products: "", role: "LSP / Referral", grievance: "" },
  ],
};

export const insurancePartners = {
  intro:
    "If insurance products are offered, they are provided by authorised insurers/intermediaries in accordance with the applicable IRDAI framework. Our exact role and any required registration will be stated here. We do not display insurer logos merely to appear larger.",
  role:
    "Our role: Referral / lead facilitation to an authorised insurance intermediary or insurer. Policy issuance, pricing and claims are handled by the authorised entity as per IRDAI norms.",
  columns: ["Partner (Legal Name)", "Type", "IRDAI Registration (if applicable)", "Products", "Our Role"],
  rows: [
    { name: "", type: "Insurer / Intermediary", rbi: "", products: "", role: "Referral" },
    { name: "", type: "Insurer / Intermediary", rbi: "", products: "", role: "Referral" },
  ],
};

export const investorInfo = {
  intro:
    "We value our investors and stakeholders who support our mission to make India financially healthy. Verified investor information is published here transparently.",
  role:
    "Investor relations: for partnership, funding or stakeholder queries, please reach us through the Contact page. Only verified investors/stakeholders are listed here.",
};

export const partnersMeta = {
  lending: {
    title: "Lending Partners",
    intro: lendingPartners.intro,
    role: lendingPartners.role,
    regLabel: "RBI Registration (if applicable)",
    productsLabel: "Products",
    showRole: true,
    showGrievance: true,
    showReg: true,
  },
  insurance: {
    title: "Insurance Partners",
    intro: insurancePartners.intro,
    role: insurancePartners.role,
    regLabel: "IRDAI Registration (if applicable)",
    productsLabel: "Products",
    showRole: true,
    showGrievance: false,
    showReg: true,
  },
  investor: {
    title: "Investors",
    intro: investorInfo.intro,
    role: investorInfo.role,
    regLabel: "Registration (if applicable)",
    productsLabel: "About",
    showRole: false,
    showGrievance: false,
    showReg: false,
  },
};

export const companyInfo = {
  intro:
    "This page provides company identity and regulatory information. Fields left blank are to be completed with verified, official details before the website is promoted.",
  fields: [
    { label: "Legal Company Name", value: "" },
    { label: "Registered Office Address", value: "" },
    { label: "CIN", value: "" },
    { label: "GSTIN", value: "" },
    { label: "Official Email", value: "" },
    { label: "Telephone", value: "" },
    { label: "Website", value: "https://loansupportindia.com" },
    { label: "Customer Support Contact", value: "" },
    { label: "Grievance Officer Contact", value: "" },
    { label: "Applicable Registrations / Licences", value: "" },
  ],
  note:
    "We do not claim to be RBI Registered / RBI Approved / RBI Licensed unless it is actually true for our company. The RBI digital-lending framework distinguishes regulated entities from Lending Service Providers (LSPs); outsourcing to an LSP does not remove the regulated entity's obligations.",
};

export const grievance = {
  intro:
    "We are committed to resolving your concerns fairly and promptly. If you have a complaint about our services, please use the process below.",
  officer: [
    { label: "Grievance Officer Name / Designation", value: "" },
    { label: "Email", value: "" },
    { label: "Phone", value: "" },
    { label: "Postal Address", value: "" },
    { label: "Expected Response Time", value: "" },
  ],
  process: [
    "Raise your complaint via the Grievance Officer contact details above with relevant reference information.",
    "You will receive an acknowledgement, and we will attempt to resolve the matter within the stated response time.",
    "If your complaint relates to a specific lender/insurer, it may be escalated to that regulated entity's grievance channel.",
    "If you are not satisfied, you may escalate further as per the applicable regulatory grievance mechanism.",
  ],
};

// Legal pages content keyed by slug
export const legalContent = {
  "privacy-policy": {
    title: "Privacy Policy",
    updated: "This Privacy Policy explains how we handle your information. (MOCK content for review.)",
    sections: [
      { h: "Information We Collect", p: "We may collect need-based information such as name, mobile number, email, date of birth, employment/business information, income, address, loan requirement, existing loan information, and (only where required and with consent) PAN. We may also collect device/browser information, IP address and cookies." },
      { h: "Why We Collect It", p: "To process your enquiry, connect you with relevant authorised partners, communicate with you, prevent fraud, improve our services, and meet regulatory/legal requirements. We follow need-based data collection and explicit consent." },
      { h: "Third-Party Sharing", p: "With your consent, information may be shared with banks, NBFCs, insurance companies, credit information providers, CRM providers, technology vendors, communication providers and analytics providers strictly for the stated purposes. We do not sell your personal information." },
      { h: "Consent & Your Rights", p: "You provide explicit consent before we process or share your information. You may withdraw consent or request access/correction/deletion, subject to legal and contractual limits." },
      { h: "Data Security & Retention", p: "We apply reasonable safeguards and restrict access to your data. We retain information only as long as necessary for the stated purposes or as required by law." },
      { h: "Contact", p: "For privacy questions, contact us through the details on our Contact and Grievance Redressal pages." },
    ],
  },
  "terms": {
    title: "Terms & Conditions",
    updated: "Please read these terms carefully before using the website. (MOCK content for review.)",
    sections: [
      { h: "Nature of Service", p: "Loansupportindia is a facilitation and lead-generation platform. We do not sanction or disburse loans and are not the lender unless legally authorised. Loan and insurance decisions are made by the respective regulated entities." },
      { h: "No Guarantee", p: "Submission of an enquiry does not guarantee loan approval. Eligibility, interest rate, tenure, fees and terms are decided by the lender/insurer." },
      { h: "User Responsibilities", p: "You agree to provide accurate information and to use the website lawfully. You are responsible for reviewing the terms and documents provided by the lender/insurer." },
      { h: "Referral / Commission", p: "We may receive referral or commission fees from partners where applicable, in accordance with the arrangement." },
      { h: "Limitation of Liability", p: "To the extent permitted by law, we are not liable for decisions made by lenders/insurers or for indirect losses arising from use of the website." },
      { h: "Governing Law", p: "These terms are governed by applicable Indian law. Jurisdiction details to be specified by the company." },
    ],
  },
  "disclaimer": {
    title: "Disclaimer",
    updated: "Important information about our services. (MOCK content for review.)",
    sections: [
      { h: "We Are Not the Lender", p: "Loansupportindia is a platform/facilitator/lead generator and is not itself the lender unless legally authorised. Loans are provided by the respective banks/NBFCs." },
      { h: "No Guarantee of Approval", p: "We do not guarantee loan approval. Approval is subject to the lender's underwriting. Interest rates, eligibility and processing fees vary and are determined by the lender." },
      { h: "Costs & Charges", p: "The actual lender will disclose the applicable interest rate, APR, processing fee, GST/taxes, tenure, EMI, penal charges, prepayment/foreclosure terms and other fees through its Key Fact Statement / documents." },
      { h: "Insurance", p: "Insurance products are subject to policy terms and conditions and are provided by authorised insurers/intermediaries under the applicable IRDAI framework." },
      { h: "Referral Fees", p: "We may receive referral/commission fees from partners where applicable." },
    ],
  },
  "cookie-policy": {
    title: "Cookie Policy",
    updated: "How we use cookies and similar technologies. (MOCK content for review.)",
    sections: [
      { h: "What Are Cookies", p: "Cookies are small files stored on your device that help the website function and help us understand usage." },
      { h: "Types We May Use", p: "Essential cookies for site functionality, analytics cookies (e.g., Google Analytics), and marketing/advertising cookies (e.g., Meta Pixel, Google Ads) where applicable." },
      { h: "Analytics & Marketing Disclosure", p: "Where enabled, we may use analytics and advertising tools to measure performance and reach. These are disclosed and, where required, subject to your consent." },
      { h: "Managing Cookies", p: "You can manage or disable cookies through your browser settings. Some features may not work correctly if certain cookies are disabled." },
    ],
  },
};
